import React, { useEffect } from 'react';
import { signOut, auth } from './firebase';
import { useNavigate } from 'react-router-dom';

const Logout: React.FC = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    signOut(auth).finally(() => navigate('/'));
  }, [navigate]);
  
  return null;
};

export default Logout; 